/**
 * System which covers all heating in system
 * - used in Olsztyn BR systems
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'

export default class Heater extends Element {
  setDefaultShapes () {
    this.shapes.push(
      new Ren.Rect({
        name: 'heater',
        x: 0,
        y: 0,
        width: 5,
        height: 60,
        strokeWidth: 0.5,
        fill: Color.offlineGray,
        opacity: 0.8
      })
    )
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    const status = newVariables || this.status
    super.applyStatusOnShapes(newVariables)

    if (status.current === 1) {
      this.modifyShape('heater', 'fill', 'red')
    } else {
      this.modifyShape('heater', 'fill', 'blue')
    }
  }
}
